<script>
import {useI18n} from "vue-i18n";
import Icon from "../../components/Icon.vue";
import {useReportStore} from "../../../stores/report";
import Index from "@/javascript/views/components/dashboard/Index.vue";

export default {
  name: "ReportHistory",
  components: {Icon, Index},
  setup() {
    // I18n
    const {t} = useI18n();
    const reportStore = useReportStore();

    return {
      t,
      reportStore
    };
  },
  data() {
    return {
      pollingInterval: null
    };
  },
  computed: {},
  watch: {
    'reportStore.reports': {
      handler() {
        this.checkProcessingReports();
      },
      deep: true,
      immediate: true
    }
  },
  beforeUnmount() {
    this.stopPolling();
  },
  mounted() {
    this.reportStore.getReports();
  },
  methods: {
    checkProcessingReports() {
      const hasProcessing = this.reportStore.reports?.some(report => report.status === 'PROCESSING' || report.status === 'CREATED');
      if (hasProcessing && !this.pollingInterval) {
        this.startPolling();
      } else if (!hasProcessing && this.pollingInterval) {
        this.stopPolling();
      }
    },
    startPolling() {
      this.pollingInterval = setInterval(() => {
        this.reportStore.getReports(true);
      }, 5000);
    },

    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    }
  }
};
</script>

<template>
  <div class="page-container">
    <div class="header">
      <div class="headline-3-regular">
        History
      </div>
      <div class="body-2-light">
        View and download past reports
      </div>
    </div>
    <index
      :model-store="reportStore"
      disable-click
      hide-search
    />
  </div>
</template>

<style scoped lang="scss">

.header {
  @apply pb-4 border-b-2 mb-4 border-gray-200;
}

.page-container {
  @apply h-full overflow-y-auto p-4;
}
</style>
